var _rect, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgXRayEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "url(#x-ray-email_svg__paint0_radial_11879_73707)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 5c-2.757 0-5 2.243-5 5s2.243 5 5 5c.88 0 1.744-.231 2.5-.67l-.625-1.081A3.754 3.754 0 016.25 10 3.754 3.754 0 0110 6.25 3.754 3.754 0 0113.75 10v.544c0 .41-.263.706-.625.706a.626.626 0 01-.625-.625v-2.5h-.864A2.479 2.479 0 0010 7.5 2.503 2.503 0 007.5 10c0 1.379 1.122 2.5 2.5 2.5.656 0 1.25-.26 1.697-.675.344.41.853.675 1.428.675 1.051 0 1.875-.859 1.875-1.956V10c0-2.757-2.243-5-5-5zm0 6.25a1.251 1.251 0 010-2.5 1.251 1.251 0 010 2.5z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "x-ray-email_svg__paint0_radial_11879_73707",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(18.84145 19.40115 -19.06592 18.51589 .793 .599)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD6CD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B3BBB"
  })))));
}

export default __webpack_public_path__ + "./fonts/x-ray-email.5a7bd2c41181245edcf2eb345a2f736a.svg";
export { SvgXRayEmail as ReactComponent };